export default "__VITE_ASSET__DPB3jV6e__"